import { render, staticRenderFns } from "./Redirection.vue?vue&type=template&id=57032e9d&scoped=true&"
import script from "./Redirection.vue?vue&type=script&lang=ts&"
export * from "./Redirection.vue?vue&type=script&lang=ts&"
import style0 from "./Redirection.vue?vue&type=style&index=0&id=57032e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57032e9d",
  null
  
)

export default component.exports